import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { SessionStorage } from 'ngx-webstorage';

import { ConfigService } from 'services/config/config.service';

import { SchoolInfo, SSTUserInfo, UserSearchResult, ValidSchoolInfo } from './application.service.class';
import { BaseRoleInfo, RoleInfo } from 'services/auth/auth.service.class';

@Injectable({
    providedIn: 'root',
})
export class ApplicationService {
    rootPath = '';

    @SessionStorage() _AllRoles!: RoleInfo[];
    @SessionStorage() _AllSchools!: SchoolInfo[];
    @SessionStorage() _AllSchoolYears!: string[];
    @SessionStorage() _CurrentSchoolYear!: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.rootPath = this.configService.hostAddress;
    }

    // #region Get All Roles

    GetAllRoles(): Observable<RoleInfo[]> {
        const self = this;

        return self._AllRoles?.length
            ? of<RoleInfo[]>(self._AllRoles)
            : self.http.get<RoleInfo[]>(this.configService.hostAddress + `api/General/roles`).pipe(
                  tap((data) => {
                      self._AllRoles = data || [];
                  })
              );
    }

    // #endregion

    // #region Get All Schools

    GetAllSchools(): Observable<SchoolInfo[]> {
        const self = this;

        return self._AllSchools?.length
            ? of<SchoolInfo[]>(self._AllSchools)
            : self.http.get<SchoolInfo[]>(this.configService.hostAddress + `api/General/schools`).pipe(
                  tap((data) => {
                      self._AllSchools = data || [];
                  })
              );
    }

    // #endregion

    // #region Get All School Years

    GetAllSchoolYears(): Observable<string[]> {
        const self = this;

        return self._AllSchoolYears?.length
            ? of<string[]>(self._AllSchoolYears)
            : self.http.get<string[]>(this.configService.hostAddress + `api/General/years`).pipe(
                  tap((data) => {
                      self._AllSchoolYears = data || [];
                  })
              );
    }

    // #endregion

    // #region Get All SST Users

    GetAllSSTUsers(currentRole: string | null | undefined): Observable<SSTUserInfo[]> {
        return this.http.get<SSTUserInfo[]>(
            this.configService.hostAddress + `Api/Services/App/GetAllUsers` + `?CurrentRole=${currentRole || ''}`
        );
    }

    // #endregion

    // #region Get Current School Year

    GetCurrentSchoolYear(): Observable<string> {
        const self = this;

        return !self._CurrentSchoolYear
            ? self.http.get<string>(self.configService.hostAddress + `api/General/currentyear`).pipe(
                  tap((data) => {
                      self._CurrentSchoolYear = '' + (data || '');
                  })
              )
            : of<string>(self._CurrentSchoolYear);
    }

    // #endregion

    // #region Get Valid Schools For User

    GetValidSchoolsForUser(): Observable<ValidSchoolInfo[]> {
        return this.http.get<ValidSchoolInfo[]>(this.configService.hostAddress + `api/General/validschools`);
    }

    // #endregion

    // #region Search For Employee By SAPID

    SearchForEmployeeBySAPID(currentRole: string | null | undefined, sAPID: string): Observable<UserSearchResult> {
        return this.http.get<UserSearchResult>(
            this.configService.hostAddress +
                `'Api/Services/App/SearchForEmployeeBySAPID'` +
                `?CurrentRole=${currentRole || ''}&SAPID=${sAPID || ''}`
        );
    }

    // #endregion

    // #region Search For User

    SearchForUser(
        currentRole: string | null | undefined,
        firstName: string | null | undefined,
        lastName: string | null | undefined,
        sAPID: string | null | undefined,
        forcedLocationNumber: string | null | undefined
    ): Observable<UserSearchResult[]> {
        return this.http.post<UserSearchResult[]>(this.configService.hostAddress + `Api/Services/App/SearchForUser`, {
            CurrentRole: currentRole || '',
            FirstName: firstName || '',
            LastName: lastName || '',
            SAPID: sAPID || '',
            SchoolNumber: forcedLocationNumber || '',
        });
    }

    // #endregion
}
